export default __webpack_public_path__ + "static/media/products.801f9241.svg";